module.exports = __webpack_public_path__ + "static/media/05PerformancePhotos.280a958c.jpeg";